import React, { Component } from 'react';
import { Piece } from 'avataaars';
import { options } from './avatarAttributes';
import 'bootstrap/dist/css/bootstrap.min.css';

const colorMap = {
  Black: '#262e33',
  Blue01: '#65c9ff',
  Blue02: '#5199e4',
  Blue03: '#25557c',
  Gray01: '#e6e6e6',
  Gray02: '#929598',
  Heather: '#3c4f5c',
  PastelBlue: '#b1e2ff',
  PastelGreen: '#a7ffc4',
  PastelOrange: '#ffdeb5',
  PastelRed: '#ffafb9',
  PastelYellow: '#ffffb1',
  Pink: '#ff5c5c',
  Red: '#ff4848',
  White: '#ffffff',
  Blonde: '#fff280',
  BlondeGolden: '#f9c85b',
  Auburn: '#a55728',
  Brown: '#724133',
  BrownDark: '#4a312c',
  Platinum: '#ecdcbf',
  SilverGray: '#e8e1e1',
};

export default class AvatarOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedType: null,
    };
    this.optionsContainerRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.props.category !== prevProps.category) {
      this.optionsContainerRef.current.scrollTop = 0;
      this.setState({ selectedType: null });
    }
  }

  selectType = (category, type) => {
    const hasColorOptions = type.hairColor || type.hatColor || type.clotheColor || type.facialHairColor;

    const mappedCategory = category === 'eyebrows' ? 'eyebrow' : category === 'eyes' ? 'eye' : category === 'mouth' ? 'mouth' : category;

    if (!hasColorOptions) {
      this.props.onOptionSelect(mappedCategory, { type: type.type });
    } else {
      const defaultColor = type.hairColor?.[0] || type.hatColor?.[0] || type.clotheColor?.[0] || type.facialHairColor?.[0];

      this.props.onOptionSelect(mappedCategory, {
        type: type.type,
        color: defaultColor,
      });

      this.setState({ selectedType: type });
    }
  };

  renderColorOptions = (category, type) => {
    const colorOptions = type.hairColor || type.hatColor || type.clotheColor || type.facialHairColor || [];

    return colorOptions.map((color, index) => (
      <div key={`${category}-${type.type}-color-${index}`} className="col-xl-2 col-md-3 col-4 mb-3">
        <div
          className="color-circle mx-auto"
          onClick={() =>
            this.props.onOptionSelect(category, {
              type: type.type,
              color,
            })
          }
          title={color}
          style={{ backgroundColor: colorMap[color] || '#ccc' }}
        />
      </div>
    ));
  };

  renderOptionPieces = (category) => {
    const columnClass = 'col-xl-2 col-md-3 col-4 mb-3';

    if (category === 'skin') {
      return options.skin.map((option, index) => (
        <div key={`skin-${option.color}-${index}`} className={columnClass}>
          <div className="card border option-card" onClick={() => this.props.onOptionSelect('skin', { color: option.color })}>
            <div className="card-body centered-piece">
              <Piece pieceType="skin" skinColor={option.color} />
            </div>
          </div>
        </div>
      ));
    }

    const categoryOptions = options[category] || [];

    return categoryOptions.map((option, index) => {
      const pieceProps =
        category === 'eyes'
          ? { pieceType: category, eyeType: option.type }
          : category === 'eyebrows'
          ? { pieceType: category, eyebrowType: option.type }
          : category === 'mouth'
          ? { pieceType: category, mouthType: option.type }
          : { pieceType: category, [`${category}Type`]: option.type };

      return (
        <div key={`${category}-${option.type}-${index}`} className={columnClass}>
          <div className="card h-100 border-0 shadow-sm option-card" onClick={() => this.selectType(category, option)}>
            <div
              className={`card-body ${
                category === 'eyes'
                  ? 'eye-piece'
                  : category === 'eyebrows'
                  ? 'eyebrow-piece'
                  : category === 'mouth'
                  ? 'mouth-piece'
                  : 'centered-piece'
              }`}
            >
              {' '}
              <Piece {...pieceProps} />
            </div>
          </div>
        </div>
      );
    });
  };

  render() {
    const { category } = this.props;
    const { selectedType } = this.state;

    return (
      <div className="container mt-3" ref={this.optionsContainerRef}>
        <div className="row">{selectedType ? this.renderColorOptions(category, selectedType) : this.renderOptionPieces(category)}</div>
      </div>
    );
  }
}
